import { createContext, useContext, useState, ReactNode } from 'react'
import WebApp from '@twa-dev/sdk'

export type Language = 'zh' | 'en'

interface LanguageContextValue {
  lang: Language
  setLang: (lang: Language) => void
  t: (zh: string, en: string) => string
}

const LanguageContext = createContext<LanguageContextValue>({
  lang: 'en',
  setLang: () => {},
  t: (_zh, en) => en,
})

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Language>(() => {
    const saved = localStorage.getItem('app_lang')
    if (saved === 'zh' || saved === 'en') return saved
    // Standalone web visitors start in Chinese; Telegram Mini App visitors in English.
    return WebApp.initData ? 'en' : 'zh'
  })

  const handleSetLang = (newLang: Language) => {
    setLang(newLang)
    localStorage.setItem('app_lang', newLang)
  }

  const t = (zh: string, en: string) => (lang === 'en' ? en : zh)

  return (
    <LanguageContext.Provider value={{ lang, setLang: handleSetLang, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage() {
  return useContext(LanguageContext)
}
